module.exports = __webpack_public_path__ + "static/media/ready-player-one.4d7fd4bb.jpeg";